// @flow

import * as React from 'react';
import Dropdown from './Dropdown';

type Props = {
  updateGranularity: Object => void,
  granularity: string,
  context?: string
};

export default class GranularitySelector extends React.Component<Props> {
  render() {
    const timeseriesOptions = [
      {
        label: 'Day',
        value: 'day'
      },
      {
        label: 'Week',
        value: 'week'
      },
      {
        label: 'Month',
        value: 'month'
      }
    ];

    const tableOptions = [
      ...timeseriesOptions,
      {
        label: 'All Time',
        value: 'all'
      }
    ];

    const { updateGranularity, granularity, context } = this.props;

    const contextIsTable = context && context.endsWith('table');

    return (
      <div className="h_miw-100">
        <Dropdown
          i13nLabel="GranularitySelector"
          options={contextIsTable ? tableOptions : timeseriesOptions}
          onChange={updateGranularity}
          value={granularity}
          clearable={false}
          testid="granularity-selector"
        />
      </div>
    );
  }
}
